(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5496],{

/***/ 18885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ cdp_week_2024; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/foundations/FontContext/index.ts
var FontContext = __webpack_require__(32151);
// EXTERNAL MODULE: ../../libs/matcha/foundations/Theme/index.ts + 30 modules
var Theme = __webpack_require__(46630);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/api/routes/cdpWeek2024/queries/index.ts + 4 modules
var queries = __webpack_require__(89500);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ./src/views/CdpWeek2024/components/Navigation/Navigation.tsx + 1 modules
var Navigation = __webpack_require__(78877);
// EXTERNAL MODULE: ./src/views/CdpWeek2024/components/Footer/Footer.tsx + 1 modules
var Footer = __webpack_require__(19917);
// EXTERNAL MODULE: ./src/views/CdpWeek2024/components/SaveYourSpot/SaveYourSpot.tsx + 1 modules
var SaveYourSpot = __webpack_require__(23176);
// EXTERNAL MODULE: ./src/views/CdpWeek2024/components/CarouselSection/CarouselSection.tsx
var CarouselSection = __webpack_require__(82616);
// EXTERNAL MODULE: ./src/views/CdpWeek2024/assets/OgImageCDPWeek2024.png
var OgImageCDPWeek2024 = __webpack_require__(13920);
var OgImageCDPWeek2024_default = /*#__PURE__*/__webpack_require__.n(OgImageCDPWeek2024);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(81333);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var recipes_Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/utils/useLottie/useLottie.tsx
var useLottie = __webpack_require__(73849);
// EXTERNAL MODULE: ../../libs/utils/useInView/index.ts + 1 modules
var useInView = __webpack_require__(85807);
// EXTERNAL MODULE: ./src/views/CdpWeek2024/utils/useDomainPath/useDomainPath.ts
var useDomainPath = __webpack_require__(24736);
;// CONCATENATED MODULE: ./src/views/CdpWeek2024/AboutPage/components/Hero/assets/hero-animation.json.data
/* harmony default export */ var hero_animation_json = ("/_next/static/data/hero-animation.json-8b2397b3ffc00f7cffd1c1a9f9df0444.json");
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/CdpWeek2024/AboutPage/components/Hero/Hero.tsx



function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }












var HEADING = "Reimagine Intelligent Engagement in the AI Era";
var DESCRIPTION = "During this three-day virtual summit, industry leaders from Fidelity, IBM, Google Cloud, and more shared how they are making every customer interaction personal. With intelligent engagement, real-time context, and AI-driven workflows, you\u2019ll learn how to increase revenue, optimize conversions and build stronger customer relationships.";
var Hero_button = {
  text: "Watch Now"
};

var Hero = function Hero() {
  var registerLink = (0,useDomainPath/* default */.Z)("register");
  (0,react.useEffect)(function () {
    setAnimationData(fetch(hero_animation_json));
  }, []);

  var _useState = (0,react.useState)(),
      animationData = _useState[0],
      setAnimationData = _useState[1];

  var _useLottie = (0,useLottie/* default */.Z)({
    options: {
      animationData: animationData,
      autoplay: true,
      loop: false
    }
  }),
      _useLottie2 = (0,slicedToArray/* default */.Z)(_useLottie, 2),
      animation = _useLottie2[0],
      containerRef = _useLottie2[1];

  var isInView = (0,useInView/* default */.Z)(containerRef);
  (0,react.useEffect)(function () {
    if (isInView && animation) {
      animation.playSegments([0, animation.totalFrames], true);
      animation.addEventListener("enterFrame", function () {
        if (animation.currentFrame >= 105) {
          animation.playSegments([105, animation.totalFrames], false);
        }
      });
    } else {
      animation === null || animation === void 0 ? void 0 : animation.stop();
    }
  }, [animation, isInView]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledHero, {
      variant: "2Col",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyTextHeading, {
            variant: "h1",
            tag: "h1",
            children: HEADING
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWrapper, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
              href: registerLink,
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
                variant: "filled",
                size: "large",
                color: "primary",
                children: Hero_button.text
              })
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            tag: "p",
            variant: "pLarge",
            children: DESCRIPTION
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Animation, {
          ref: containerRef
        })
      })]
    })
  });
};

/* harmony default export */ var Hero_Hero = (Hero);

var CopyTextHeading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Heading */.X6,  true ? {
  target: "e185rzr4"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("lg");
}, "{max-width:480px;}" + ( true ? "" : 0));

var Animation = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e185rzr3"
} : 0)("width:120%;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.down("md");
}, "{width:110%;}" + ( true ? "" : 0));

var StyledHero = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* default */.ZP,  true ? {
  target: "e185rzr2"
} : 0)(recipes_Hero/* Wrapper */.im, "{gap:100px;padding-top:0;padding-bottom:0;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down("md");
}, "{gap:40px;grid-template-areas:'contents' 'copy';}}" + ( true ? "" : 0));

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e185rzr1"
} : 0)("position:relative;", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.down("md");
}, "{padding-bottom:40px;}" + ( true ? "" : 0));

var ButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e185rzr0"
} : 0)( true ? {
  name: "zhi4ni",
  styles: "margin:32px 0"
} : 0);
// EXTERNAL MODULE: ../../node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(13102);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
;// CONCATENATED MODULE: ./src/views/CdpWeek2024/AboutPage/components/AboutCDPWeek/AboutCDPWeek.tsx



function AboutCDPWeek_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var OVERLINE = "About CDP Week";
var AboutCDPWeek_HEADING = "Maximize your experience";
var description = ["Companies who win, win with personalization. But precise engagement is hard to deliver. Just ask Gartner, whose research highlights that $96B is wasted every year on solutions to drive tailored customer experiences.", "The next era of customer engagement is here, and we gathered industry experts to share their experiences from the frontlines.", "Whether you're looking to enhance customer trust, improve operational efficiencies, or drive innovation, our sessions showcased how it\u2019s never been easier to deliver personalized engagement within the AI era."];

var AboutCDPWeek = function AboutCDPWeek() {
  var _useState = (0,react.useState)(function () {
    return __webpack_require__.e(/* import() */ 487).then(__webpack_require__.bind(__webpack_require__, 50487)).then(function (module) {
      return module["default"];
    });
  }),
      animationData = _useState[0];

  var _useLottie = (0,useLottie/* default */.Z)({
    options: {
      autoplay: false,
      animationData: animationData,
      loop: true
    }
  }),
      _useLottie2 = (0,slicedToArray/* default */.Z)(_useLottie, 2),
      animation = _useLottie2[0],
      containerRef = _useLottie2[1];

  var isInView = (0,useInView/* default */.Z)(containerRef, {
    stopOnIntersection: false
  });
  (0,react.useEffect)(function () {
    if (isInView && animation) {
      animation.playSegments([0, 535], true);
      animation.addEventListener("enterFrame", function () {
        if (animation.currentFrame >= 91) {
          animation.playSegments([91, 535], false);
        }
      });
    } else {
      animation === null || animation === void 0 ? void 0 : animation.stop();
    }
  }, [animation, isInView]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AboutCDPWeek_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
      variant: "2Col",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Copy */.CK, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
            children: OVERLINE
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            tag: "h2",
            children: AboutCDPWeek_HEADING
          })]
        }), description.map(function (el) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
            variant: "pLarge",
            children: el
          }, el);
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AboutCDPWeek_Animation, {
        ref: containerRef
      })]
    })
  });
};

/* harmony default export */ var AboutCDPWeek_AboutCDPWeek = (AboutCDPWeek);

var AboutCDPWeek_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e19oq44p1"
} : 0)("background:", function (_ref) {
  var theme = _ref.theme;
  return "linear-gradient(0deg, ".concat((0,polished_esm/* transparentize */.DZ)(0.76, theme.palette.neutrals.black[100]), " 0%, ").concat((0,polished_esm/* transparentize */.DZ)(0.76, theme.palette.neutrals.black[100]), " 100%), ").concat(theme.palette.cdpWeek2023.gray[100]);
}, ";" + ( true ? "" : 0));

var AboutCDPWeek_Animation = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e19oq44p0"
} : 0)( true ? {
  name: "te9zy8",
  styles: "width:110%"
} : 0);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ./src/views/CdpWeek2024/components/List/List.tsx
var List = __webpack_require__(92016);
// EXTERNAL MODULE: ./src/views/CdpWeek2024/components/List/Item.tsx
var Item = __webpack_require__(7042);
;// CONCATENATED MODULE: ./src/views/CdpWeek2024/AboutPage/components/Plan/assets/cdp_week_lottie_icon.json.data
/* harmony default export */ var cdp_week_lottie_icon_json = ("/_next/static/data/cdp_week_lottie_icon.json-1a095c713672570fa94e15ad6c5206c0.json");
;// CONCATENATED MODULE: ./src/views/CdpWeek2024/AboutPage/components/Plan/Plan.tsx



function Plan_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }















var Plan_HEADING = "You\u2019ll walk away with:";
var list = ["Inspiration to leverage AI to unlock customer insights and deliver personalized experiences that drive loyalty and sustainable growth", "Insights to stay ahead of the evolving digital advertising landscape while optimizing your strategy and driving campaign efficiency", "Strategies to maintain a source of truth in the warehouse and activate unified customer profiles downstream - empowering every team with self-serve access to trusted data"];

var Plan = function Plan() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();

  var _useState = (0,react.useState)(),
      animationData = _useState[0],
      setAnimationData = _useState[1];

  var registerLink = (0,useDomainPath/* default */.Z)("register");
  var agendaLink = (0,useDomainPath/* default */.Z)("agenda");
  (0,react.useEffect)(function () {
    setAnimationData(fetch(cdp_week_lottie_icon_json));
  }, []);
  var buttons = (0,react.useMemo)(function () {
    return [{
      name: "Watch Now",
      href: registerLink,
      variant: "filled"
    }, {
      name: "View the agenda",
      href: agendaLink,
      variant: "outlined"
    }];
  }, [registerLink, agendaLink]);

  var _useLottie = (0,useLottie/* default */.Z)({
    options: {
      autoplay: false,
      animationData: animationData,
      loop: true
    }
  }),
      _useLottie2 = (0,slicedToArray/* default */.Z)(_useLottie, 2),
      animation = _useLottie2[0],
      containerRef = _useLottie2[1];

  var isInView = (0,useInView/* default */.Z)(containerRef);
  (0,react.useEffect)(function () {
    if (isInView && animation) {
      animation.playSegments([0, animation.totalFrames], true);
      animation.addEventListener("enterFrame", function () {
        if (animation.currentFrame >= 103) {
          animation.playSegments([104, animation.totalFrames], false);
        }
      });
    } else {
      animation === null || animation === void 0 ? void 0 : animation.stop();
    }
  }, [animation, isInView]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Plan_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSection, {
      variant: "2Col",
      reverse: true,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Plan_Animation, {
          ref: containerRef
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Copy */.CK, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            tag: "h2",
            children: Plan_HEADING
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(List/* default */.Z, {
            children: list.map(function (item, key) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Item/* default */.Z, {
                children: item
              }, key);
            })
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonsWrapper, {
          children: buttons.map(function (button) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
              variant: button.variant,
              href: (0,getAbsoluteUrl/* default */.Z)(button.href, pageConfig),
              size: "large",
              color: "primary",
              children: button.name
            }, button.name);
          })
        })]
      })]
    })
  });
};

/* harmony default export */ var Plan_Plan = (Plan);

var Plan_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eg14rre4"
} : 0)("background:", function (_ref) {
  var theme = _ref.theme;
  return "linear-gradient(0deg, ".concat((0,polished_esm/* transparentize */.DZ)(0.76, theme.palette.neutrals.black[100]), " 0%, ").concat((0,polished_esm/* transparentize */.DZ)(0.76, theme.palette.neutrals.black[100]), " 100%), ").concat(theme.palette.cdpWeek2023.gray[100]);
}, ";" + ( true ? "" : 0));

var StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "eg14rre3"
} : 0)(Section/* Wrapper */.im, "{gap:300px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.down("md");
}, "{padding-bottom:0;gap:80px;}}" + ( true ? "" : 0));

var Plan_Animation = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eg14rre2"
} : 0)( true ? {
  name: "88v4fd",
  styles: "width:120%"
} : 0);

var ListWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eg14rre1"
} : 0)( true ? {
  name: "3hgi0y",
  styles: "margin-top:32px"
} : 0);

var ButtonsWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eg14rre0"
} : 0)( true ? {
  name: "waeun9",
  styles: "margin-top:32px;display:flex;gap:20px;align-items:center"
} : 0);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/components/Modal/useModal.ts
var useModal = __webpack_require__(95290);
// EXTERNAL MODULE: ../../libs/matcha/recipes/RichText/index.ts
var RichText = __webpack_require__(47756);
// EXTERNAL MODULE: ./src/views/CdpWeek2024/components/SpeakerModal/SpeakerModal.tsx
var SpeakerModal = __webpack_require__(86164);
// EXTERNAL MODULE: ./src/views/CdpWeek2024/components/SpeakerCard/SpeakerCard.tsx
var SpeakerCard = __webpack_require__(81300);
;// CONCATENATED MODULE: ./src/views/CdpWeek2024/AboutPage/components/MeetOurSpeakers/MeetOurSpeakers.tsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function MeetOurSpeakers_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
















var copy = {
  overline: "Meet Our Speakers",
  title: "Unveil new insights and learn from experts",
  description: "From building a best-in-class data infrastructure to delivering intelligent customer engagement across every channel, watch the sessions on-demand to hear from business leaders and industry experts on how trusted data and real-time customer profiles are enabling faster innovation, seamless customer experiences and personalized customer connections that drive loyalty.",
  button: "View all speakers"
};

var MeetOurSpeakers = function MeetOurSpeakers(_ref) {
  var _ref2, _selectedSpeaker$sess, _featuredSession$sess, _featuredSession$sess2;

  var speakers = _ref.speakers;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var speakersLink = (0,useDomainPath/* default */.Z)("speakers");
  var modalRef = (0,react.useRef)(null);

  var _useState = (0,react.useState)(null),
      selectedSpeaker = _useState[0],
      setSelectedSpeaker = _useState[1];

  var modalOpenState = (0,react.useState)(false);

  var _modalOpenState = (0,slicedToArray/* default */.Z)(modalOpenState, 1),
      opened = _modalOpenState[0];

  var _useModal = (0,useModal/* default */.Z)(modalRef, modalOpenState),
      getControlOpenProps = _useModal.getControlOpenProps,
      getControlCloseProps = _useModal.getControlCloseProps;

  var featuredSession = (_ref2 = (_selectedSpeaker$sess = selectedSpeaker === null || selectedSpeaker === void 0 ? void 0 : selectedSpeaker.sessions.find(function (session) {
    return session.featuredSession;
  })) !== null && _selectedSpeaker$sess !== void 0 ? _selectedSpeaker$sess : selectedSpeaker === null || selectedSpeaker === void 0 ? void 0 : selectedSpeaker.sessions[0]) !== null && _ref2 !== void 0 ? _ref2 : null;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SpeakerModal/* default */.Z, {
      ref: modalRef,
      opened: opened,
      speaker: selectedSpeaker && {
        name: selectedSpeaker.speakerName,
        company: selectedSpeaker.speakerCompany,
        title: selectedSpeaker.speakerTitle,
        image: selectedSpeaker.speakerHeadshot.src,
        sessionTitle: (_featuredSession$sess = featuredSession === null || featuredSession === void 0 ? void 0 : featuredSession.sessionTitle) !== null && _featuredSession$sess !== void 0 ? _featuredSession$sess : "",
        sessionDate: (_featuredSession$sess2 = featuredSession === null || featuredSession === void 0 ? void 0 : featuredSession.sessionDateTimePdt) !== null && _featuredSession$sess2 !== void 0 ? _featuredSession$sess2 : ""
      },
      onCloseClick: getControlCloseProps().onClick,
      children: selectedSpeaker && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RichText/* default */.ZP, {
        data: selectedSpeaker.speakerBio
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
      variant: "centered",
      copyVariant: "narrow",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledCopyText, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
          children: copy.overline
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          children: copy.title
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pLarge",
          children: copy.description
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledColumnTrack, {
          columns: 1,
          overrides: {
            lg: 3
          },
          children: speakers === null || speakers === void 0 ? void 0 : speakers.map(function (speaker) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SpeakerCard/* default */.Z, _objectSpread({
              name: speaker.speakerName,
              company: speaker.speakerCompany,
              title: speaker.speakerTitle,
              image: speaker.speakerHeadshot.src
            }, getControlOpenProps({
              onClick: function onClick() {
                setSelectedSpeaker(speaker);
              }
            })), speaker.speakerName);
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
        variant: "outlined",
        color: "primary",
        size: "large",
        href: (0,getAbsoluteUrl/* default */.Z)(speakersLink, pageConfig),
        children: copy.button
      })]
    })]
  });
};

var StyledColumnTrack = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ColumnTrack/* default */.Z,  true ? {
  target: "e1x7b38g1"
} : 0)( true ? {
  name: "xw24us",
  styles: "max-width:1120px;margin:0 auto"
} : 0);

var StyledCopyText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* default */.ZP,  true ? {
  target: "e1x7b38g0"
} : 0)( true ? {
  name: "y7xa1h",
  styles: "max-width:854px;margin:0 auto"
} : 0);

/* harmony default export */ var MeetOurSpeakers_MeetOurSpeakers = (MeetOurSpeakers);
;// CONCATENATED MODULE: ./src/views/CdpWeek2024/AboutPage/CdpWeek2024.tsx



function CdpWeek2024_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CdpWeek2024_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CdpWeek2024_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CdpWeek2024_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
















 // CdpWeek2024 page is hosted on the different domain then the rest of the app
// so we don't want to use an absolute urls for the links



var customPageConfig = {
  baseUrl: ""
};

var CdpWeek2024View = function CdpWeek2024View() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var defaultPageConfig = (0,page/* usePageConfig */.Gm)();

  var pageConfig = CdpWeek2024_objectSpread(CdpWeek2024_objectSpread({}, defaultPageConfig), customPageConfig);

  var _useCdpWeekSpeakerLan = (0,queries/* useCdpWeekSpeakerLandingPageQuery */.lI)({
    args: [{
      speakersLimit: 3
    }]
  }),
      speakers = _useCdpWeekSpeakerLan.data;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FontContext/* FontProvider */.j, {
    font: Theme/* whitneyFont */.IG,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(page/* PageConfigProvider */.i$, {
      value: pageConfig,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
        appearance: "cdpWeek2023",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
          pageTitle: "CDP Week | Twilio Segment",
          pageDescription: "CDP Week is the premier industry conference for customer data leaders.",
          bodyBackground: theme.palette.cdpWeek2023.gray[100],
          pageOG: (OgImageCDPWeek2024_default()),
          canonicalUrl: "https://cdpweek.com/",
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Hero, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AboutCDPWeek_AboutCDPWeek, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Plan_Plan, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CarouselSection/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MeetOurSpeakers_MeetOurSpeakers, {
              speakers: speakers
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SaveYourSpot/* default */.Z, {})]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
        })
      })
    })
  });
};

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "e1cesiby0"
} : 0)("overflow:hidden;background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.cdpWeek2023.gray[100];
}, ";" + ( true ? "" : 0));

/* harmony default export */ var AboutPage_CdpWeek2024 = (CdpWeek2024View);
// EXTERNAL MODULE: ../../libs/contexts/staticSiteBackend.ts
var contexts_staticSiteBackend = __webpack_require__(86708);
;// CONCATENATED MODULE: ./src/pages/cdp-week-2024/index.tsx





var CdpWeek2024 = function CdpWeek2024() {
  var staticSiteBackend = (0,react.useMemo)(function () {
    return (0,contexts_staticSiteBackend/* createStaticSiteBackend */.I4)();
  }, []);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(contexts_staticSiteBackend/* StaticSiteBackendProvider */.D1, {
    value: staticSiteBackend,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AboutPage_CdpWeek2024, {})
  });
};

var __N_SSG = true;
/* harmony default export */ var cdp_week_2024 = (CdpWeek2024);

/***/ }),

/***/ 7042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52903);


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



var Item = function Item(_ref) {
  var children = _ref.children;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(StyledItem, {
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(ContentWrapper, {
      children: children
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Item);

var StyledItem = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("li",  true ? {
  target: "e17ky5p11"
} : 0)(function (_ref2) {
  var theme = _ref2.theme;
  return theme.typography.pSmall.css;
}, ";white-space:nowrap;max-width:100%;margin:8px 0;color:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.cdpWeek2023.gray[10];
}, ";&::marker{margin-right:10px;color:", function (_ref4) {
  var theme = _ref4.theme;
  return theme.palette.cdpWeek2023.mint[100];
}, ";}" + ( true ? "" : 0));

var ContentWrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e17ky5p10"
} : 0)( true ? {
  name: "vdf4vj",
  styles: "white-space:normal;vertical-align:top;display:inline-block;width:calc(100% - 32px);p{margin:0;}"
} : 0);

/***/ }),

/***/ 92016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52903);



var List = function List(_ref) {
  var children = _ref.children;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(StyledList, {
    children: children
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (List);

var StyledList = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("ul",  true ? {
  target: "ewklxs10"
} : 0)(function (_ref2) {
  var theme = _ref2.theme;
  return theme.typography.pMedium;
}, ";padding-left:0;color:", function (_ref3) {
  var color = _ref3.color;
  return color;
}, ";margin:8px 0;list-style-position:inside;display:flex;flex-direction:column;gap:16px;" + ( true ? "" : 0));

/***/ }),

/***/ 81300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var _segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74870);
/* harmony import */ var _segment_matcha_components_Icons_Common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6580);
/* harmony import */ var _segment_matcha_recipes_Card__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74881);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52903);


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var SpeakerCard = function SpeakerCard(_ref) {
  var name = _ref.name,
      title = _ref.title,
      company = _ref.company,
      image = _ref.image,
      onClick = _ref.onClick;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(StyledCard, {
    tag: "button",
    onClick: onClick,
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(CardImageWrapper, {
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(CardImage, {
        src: image,
        alt: name
      })
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_segment_matcha_recipes_Card__WEBPACK_IMPORTED_MODULE_3__/* .Body */ .uT, {
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_segment_matcha_recipes_Card__WEBPACK_IMPORTED_MODULE_3__/* .Copy */ .CK, {
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_segment_matcha_recipes_Card__WEBPACK_IMPORTED_MODULE_3__/* .Headline */ .s0, {
          tag: "h3",
          children: name
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_segment_matcha_recipes_Card__WEBPACK_IMPORTED_MODULE_3__/* .Description */ .dk, {
          children: [title, ", ", company]
        })]
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_segment_matcha_recipes_Card__WEBPACK_IMPORTED_MODULE_3__/* .Action */ .aU, {
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
          tag: "span",
          size: "small",
          iconEnd: _segment_matcha_components_Icons_Common__WEBPACK_IMPORTED_MODULE_2__/* .ChevronRightIcon */ .XC,
          children: "See their bio"
        })
      })]
    })]
  });
};

var CardImageWrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e1uwyhbv2"
} : 0)("--transition:0.5s ease-in-out;grid-area:image;width:calc(100% - 64px);max-width:250px;height:auto;margin:24px auto 0;border-radius:50%;overflow:hidden;position:relative;::before{display:block;content:'';position:absolute;top:0px;right:0px;bottom:0px;left:0px;border-radius:50%;border:8px solid #f22f46;z-index:1;opacity:0;transition:opacity var(--transition);}", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{margin:32px auto 0;}" + ( true ? "" : 0));

var CardImage = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_segment_matcha_recipes_Card__WEBPACK_IMPORTED_MODULE_3__/* .Image */ .Ee,  true ? {
  target: "e1uwyhbv1"
} : 0)( true ? {
  name: "19dyb3s",
  styles: "grid-area:none;height:100%;width:100%;transition:transform var(--transition);margin:0;padding:0"
} : 0);

var StyledCard = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_segment_matcha_recipes_Card__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP,  true ? {
  target: "e1uwyhbv0"
} : 0)("text-align:left;cursor:pointer;&:hover{", CardImage, "{transform:scale(1.1);}", CardImageWrapper, "::before{opacity:1;}}" + ( true ? "" : 0));

/* harmony default export */ __webpack_exports__["Z"] = (SpeakerCard);

/***/ }),

/***/ 86164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28316);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(28543);
/* harmony import */ var _segment_matcha_components_Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4203);
/* harmony import */ var _segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74870);
/* harmony import */ var _segment_matcha_components_Icons_Common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6580);
/* harmony import */ var _segment_matcha_components_Typography__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89533);
/* harmony import */ var _segment_matcha_components_Modal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(33400);
/* harmony import */ var views_CdpWeek2024_utils_useLocalDate__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(13655);
/* harmony import */ var _segment_utils_usePortal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47694);
/* harmony import */ var _segment_utils_getAbsoluteUrl_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(43848);
/* harmony import */ var _segment_contexts_page__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(17782);
/* harmony import */ var _utils_useDomainPath__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(24736);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(52903);


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

















var BUTTON_TEXT = "View the agenda";
var SpeakerModal = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function (_ref, ref) {
  var _speaker$sessionDate;

  var speaker = _ref.speaker,
      opened = _ref.opened,
      onCloseClick = _ref.onCloseClick,
      children = _ref.children;
  var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__.u)();
  var pageConfig = (0,_segment_contexts_page__WEBPACK_IMPORTED_MODULE_9__/* .usePageConfig */ .Gm)();
  var modalsRoot = (0,_segment_utils_usePortal__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)("speaker-modal");
  var localDate = (0,views_CdpWeek2024_utils_useLocalDate__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((_speaker$sessionDate = speaker === null || speaker === void 0 ? void 0 : speaker.sessionDate) !== null && _speaker$sessionDate !== void 0 ? _speaker$sessionDate : "");
  var agendaLink = (0,_utils_useDomainPath__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)("agenda");
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .Fragment */ .HY, {
    children: opened && speaker !== null && /*#__PURE__*/(0,react_dom__WEBPACK_IMPORTED_MODULE_1__.createPortal)((0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsxs */ .BX)(_segment_matcha_components_Modal__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
      size: "xlarge",
      ref: ref,
      placement: "center",
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsxs */ .BX)(_segment_matcha_components_Modal__WEBPACK_IMPORTED_MODULE_7__/* .Head */ .Fb, {
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsxs */ .BX)(Header, {
          children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(StyledImage, {
            src: speaker.image,
            alt: "Portrait of ".concat(speaker.name)
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsxs */ .BX)(Info, {
            children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(StyledTypography, {
              variant: "h4",
              children: speaker.name
            }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsxs */ .BX)(StyledTypography, {
              variant: "pMedium",
              children: [speaker.title, " ", speaker.company]
            })]
          })]
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(CloseButton, {
          onClick: onCloseClick,
          children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_segment_matcha_components_Icons_Common__WEBPACK_IMPORTED_MODULE_5__/* .ClearIcon */ .Rk, {
            color: theme.palette.neutrals.white[100],
            size: "large"
          })
        })]
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsxs */ .BX)(_segment_matcha_components_Modal__WEBPACK_IMPORTED_MODULE_7__/* .Body */ .uT, {
        children: [children, (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_segment_matcha_components_Typography__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
          variant: "h5",
          children: speaker.sessionTitle
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(StyledTypography, {
          variant: "textBold",
          tokens: {
            color: theme.palette.cdpWeek2023.saffron[100]
          },
          children: localDate
        })]
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_segment_matcha_components_Modal__WEBPACK_IMPORTED_MODULE_7__/* .Footer */ .$_, {
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
          variant: "secondary",
          iconEnd: _segment_matcha_components_Icons_Common__WEBPACK_IMPORTED_MODULE_5__/* .ChevronRightIcon */ .XC,
          size: "small",
          href: (0,_segment_utils_getAbsoluteUrl_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(agendaLink, pageConfig),
          children: BUTTON_TEXT
        })
      })]
    }), modalsRoot)
  });
});

var StyledTypography = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_segment_matcha_components_Typography__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,  true ? {
  target: "eq5cx0o4"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);

var CloseButton = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("button",  true ? {
  target: "eq5cx0o3"
} : 0)( true ? {
  name: "80292a",
  styles: "align-self:start;cursor:pointer"
} : 0);

var StyledImage = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_segment_matcha_components_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,  true ? {
  target: "eq5cx0o2"
} : 0)( true ? {
  name: "18dhbdw",
  styles: "width:96px;height:96px;border-radius:50%;margin-left:4px;object-fit:cover"
} : 0);

var Header = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "eq5cx0o1"
} : 0)( true ? {
  name: "15wwxrw",
  styles: "display:grid;grid-auto-flow:column;align-items:center;gap:12px"
} : 0);

var Info = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "eq5cx0o0"
} : 0)( true ? {
  name: "kbb71s",
  styles: "display:grid;gap:14px"
} : 0);

/* harmony default export */ __webpack_exports__["Z"] = (SpeakerModal);

/***/ }),

/***/ 79721:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cdp-week-2024",
      function () {
        return __webpack_require__(18885);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7642,947,3661,3287,9097,6577,9137,3254,9129,8943,871,1382,4136,2073,4274,7096,2429,1367,948,3996,8187,8726,7960,6012,8392,1346,4881,5062,4431,9774,2888,179], function() { return __webpack_exec__(79721); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);